import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InfoButton from '../selectComponents/InfoButton';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

const BboxSelect = (props) => {
	const { userParams, setUserParams, setShowGoButton } = props;
	const [bbox, setBbox] = useState(Array(4).fill(''));
	const [ boxError, setBoxError ] = useState(Array(4).fill(false));

	const directions = [ 'West', 'South', 'East', 'North' ];

	const handleChange = (event, index) => {
		const newBbox = bbox;
		const newBoxError = boxError;
		let newValue = event.target.value;
		// longitude must be negative
		if ((index === 0 || index === 2) && newValue > 0) {
			newValue = newValue * -1.0;
		}
		newBbox[index] = newValue;
		setBbox(newBbox);
		newBoxError[index] = isNaN(newValue);
		setBoxError(newBoxError);
		setUserParams({...userParams, areaType: "bbox", area: newBbox.join(',')});
		setShowGoButton(true)
	};
	
	useEffect(() => {
		const splitArea = userParams.areaType === 'bbox' ? userParams.area.split(',') : [];
		setBbox(splitArea.length === 4 ? splitArea : Array(4).fill(''))
	}, []);

	return (
		<Box sx={{ mt: 0 }}>
			<FieldsetBox component="fieldset" sx={{ mt: 0 }}>
				<LegendStyled>Bounding box</LegendStyled>
				<Typography variant="body2" sx={{ mb: 1, fontStyle: 'italic' }}>
					Specify bounding box in decimal degrees
				</Typography>
				{bbox.map((cl, k) => 
					<TextField
						key={k}
						label={directions[k]}
						value={cl}
						autoFocus={k === 0}
						onChange={(event) => handleChange(event, k)}
						error={boxError[k]}
						sx={{ width: "8ch",  mt: 0, mb: 0, mr: 1 }} 
						inputProps={{sx: { p: 1}}}
					/>
				)}
				<InfoButton 
					infoFor="bbox"
					edge={false}
					sx={{ p: 0, mt: 1 }}
				/>	
			</FieldsetBox>
		</Box>
		);
	}

export default BboxSelect;
